import getFormData from "../../helpers/getFormData";
import createReducer from "./createReducer";

const formDataReducer = createReducer(getFormData(), {});

export default formDataReducer;
